module.exports = __webpack_public_path__ + "static/media/dp.84936a4e.jpg";